import React from 'react';

export default React.createContext({ readOnly: false, disabled: false });
